import React, {  useState } from 'react'
import {  Segment, Form, Button, Dimmer, Loader } from 'semantic-ui-react';
import { Formik } from 'formik';
import dayjs from 'dayjs';
import { toast } from "react-toastify";
import APIService from '../../Services/API/APIService';
import * as Yup from "yup";
import ReactDatePicker from 'react-datepicker';

const ApplyDiscount = (prop) => {

     const [loading] = useState(false)
    //const [bookedDays, setBookingDays] = useState([])

    // const fetchData = async () => {
    //     try {

    //         setLoading(true);
    //         let response = await APIService.getData('/guest-house/getLatestDay', {
    //             room: prop.booking.GuestHousePackage.roomCode
    //         })

            
    //         setBookingDays(response)
            
    //         setLoading(false)
    //     } catch (error) {
         
    //         console.log(error);
    //         setLoading(false)
    //     }
    // }

    
//   useEffect(() => {
//     startTransition(async () => await fetchData());
//   }, []);

    const applyDiscount = async (values, { setSubmitting }) => {
        try {
            setSubmitting(true)
            let response = await APIService.postData('/checkout/applyDiscount', {

                bookingCode: prop.booking?.bookingId,
                GuestHouseBookingId: prop.booking?.id,
                GuestHousePackageId: prop.booking?.GuestHousePackageId,
                GuestHousePaymentId: prop.booking?.GuestHousePaymentId,
                amount: values.amount,
                date : values.date


            })

            prop.toggleDiscount(false)

            if (response) {
                toast.success(response)
            }
            setSubmitting(false)
        } catch (error) {
            toast.warn(error)
            setSubmitting(false)
        }
    }

    const schema = Yup.object().shape({
        amount: Yup.number().required("Required"),
        date: Yup.date().required('Date required')

    });

    return (
        <div>
            {loading && (
                <Dimmer active inverted>
                    <Loader />
                </Dimmer>
            )}

            <Segment textAlign="left" loading={loading}>

                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        amount: "",
                        date: ''

                    }}
                    validationSchema={schema}
                    onSubmit={applyDiscount}
                >
                    {(props) => {
                        const {
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleSubmit,
                            isSubmitting
                        } = props;
                        return (
                            <Form onSubmit={handleSubmit}>

                                <Form.Input
                                    type='number'
                                    placeholder="amount"
                                    name="amount"

                                    value={values.amount}
                                    onChange={handleChange}
                                    error={touched.amount && errors.amount}
                                />
                         
                                <Form.Input
                                    control={ReactDatePicker}
                                    placeholderText="Select a date"
                                    minDate={dayjs(prop.booking.checkedInDate).toDate()}
                                    maxDate={dayjs(prop.booking.checkout).toDate()}
                                    label="Discount Start Date"
                                    selected={
                                        values.date
                                            ? dayjs(values.date).toDate()
                                            : ""
                                    }
                                    onChange={(value) => {
                                        props.setFieldValue("date", value);
                                    }}
                                    error={touched.date && errors.date}
                                />
                       
                                <Button style={{ backgroundColor: '#26f09e', color: '#000000' }}
                                    content={isSubmitting ? 'Submitting' : 'Apply Discount'}
                                    disabled={isSubmitting}
                                />
                            </Form>
                        );
                    }}
                </Formik>

            </Segment>

        </div>
    )
}

export default ApplyDiscount